import pmCommitmentQualityService from '@/services/pmCommitmentQualityService';

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null,
    data: null,
  },

  getters: {
    loading: (state) => state.loading,
    error: (state) => state.error,
    data: (state) => state.data,
    insufficientData: (state) => Boolean(state.data?.insufficientData),
    reliabilityPercent: (state) => state.data?.reliabilityPercent ?? null,
    ownershipPercent: (state) => state.data?.ownershipPercent ?? null,
    metrics: (state) => state.data?.metrics || [],
    periodLabel: (state) => state.data?.periodLabel || '',
    totalCommitments: (state) => state.data?.totalCommitments ?? 0,
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    RESET(state) {
      state.loading = false;
      state.error = null;
      state.data = null;
    },
  },

  actions: {
    async fetchCommitmentQuality({ commit, rootGetters }) {
      const projectId = rootGetters['pmProject/selectedProjectId'];
      if (!projectId) {
        commit('RESET');
        return null;
      }

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const data = await pmCommitmentQualityService.getProjectCommitmentQuality(projectId);
        commit('SET_DATA', data);
        return data;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load commitment quality');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
